export default __webpack_public_path__ + "static/media/Aura-Egg__03.f6b00573.png";